import { build } from "app/main/tools/ConfigBuilder";
import { lazy } from "react";

const factoringRequestPath = {
	path: "/admin/factoring/factoring-requests",
	component: lazy(() => import("./AdminFactoringRequestsPage")),
};

export default build([...(false ? [factoringRequestPath] : [])]); // TODO: WALLET_FEATURE gk
